export class ConnectBYOAppsRequest {
    'customerTenantId';
    'dataAccessAppId';
    'dataAccessServicePrincipalId';
    'dataAccessAppSecretUrl';
    'managementAppId';
    'managementServicePrincipalId';
    'managementAppSecretUrl';
    'kvAccessAppServicePrincipalId';
    'dataAccessFederatedMiResourceId';
    'agentAppId';
    'agentServicePrincipalId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "customerTenantId",
            "baseName": "customerTenantId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "dataAccessAppId",
            "baseName": "dataAccessAppId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "dataAccessServicePrincipalId",
            "baseName": "dataAccessServicePrincipalId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "dataAccessAppSecretUrl",
            "baseName": "dataAccessAppSecretUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "managementAppId",
            "baseName": "managementAppId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "managementServicePrincipalId",
            "baseName": "managementServicePrincipalId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "managementAppSecretUrl",
            "baseName": "managementAppSecretUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "kvAccessAppServicePrincipalId",
            "baseName": "kvAccessAppServicePrincipalId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "dataAccessFederatedMiResourceId",
            "baseName": "dataAccessFederatedMiResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "agentAppId",
            "baseName": "agentAppId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "agentServicePrincipalId",
            "baseName": "agentServicePrincipalId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return ConnectBYOAppsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
